jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
	genderSelectPage: {
		initialValueMainGender: null,

		init: function () {
			this.tracking.trackPageView();
			this.renderInitialState();

			document.querySelectorAll('#changeGenderForm input[name="gender"]').forEach((el) => {
				el.addEventListener('click', (ev) => {
					const value = ev.currentTarget.value;
					if (value === this.initialValueMainGender) {
						return;
					}
					this.selectMainGender();
					this.tracking.trackMainGenderChange(value, this.initialValueMainGender);
					this.initialValueMainGender = value;
				});
			});

			this.initialValueMainGender = document.querySelector('#changeGenderForm input:checked')?.value;
		},

		renderInitialState: function () {
			if (document.querySelector('#changeGenderForm input[name="gender"]:checked')) {
				document.querySelector('#nextButton').disabled = false;
			}
		},

		selectMainGender: function () {
			document.querySelector('#nextButton').disabled = false;
		},

		tracking: {
			trackPageView: function () {
				jPar.util.log.bigData({
					category: 'registration',
					subcategory: 'own_gender_select_screen',
					action: 'screen_view',
				});
			},

			trackMainGenderChange: function (newGender, oldGender) {
				const createValueForTracking = (gender) => {
					switch (gender) {
						case 'MALE':
							return 'button_man';

						case 'FEMALE':
							return 'button_woman';

						case 'DIVERSE':
							return 'button_nonbinary';
					}
				};

				jPar.util.log.bigData({
					category: 'registration',
					subcategory: 'own_gender_select_screen',
					action: 'click',
					targetId: 'gender',
					cd1: createValueForTracking(oldGender) || '',
					cd2: createValueForTracking(newGender),
				});
			},
		},
	},
});
